<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="3">
        <el-button type="primary" icon="plus" @click="addTemplate" style="width: 100%" size="mini">添加宣传链接</el-button>
      </el-col>
      <el-col :span="5">
        <el-input placeholder="链接内容" v-model="params.content" style="width: 100%" size="mini"></el-input>
      </el-col>
       <el-col :span="5">
        <el-select size="small" v-model="params.content_type" clearable placeholder="所属类型" @change="typesearch">
            <el-option v-for="item in content_types" :key="item.value" :label="item.name" size="mini" :value="item.value"> </el-option>
        </el-select>
      </el-col>
      <el-col :span="5">
        <el-select size="small" v-model="params.links_type" clearable placeholder="链接类型" @change="typesearch">
            <el-option v-for="item in links_types" :key="item.value" :label="item.name" size="mini" :value="item.value"> </el-option>
        </el-select>
      </el-col>

    </el-row>

   <el-table :data="data" :height="wheight-130" v-loading="loading">
      <el-table-column prop="id" label="ID" width="100"></el-table-column>
      <el-table-column prop="content" label="链接内容" width="200"></el-table-column>
      <el-table-column prop="content_type" label="所属类型" width="100"></el-table-column>

      <el-table-column prop="links_type" label="链接类型" width="100"></el-table-column>
      <el-table-column prop="links" label="链接地址" width="200">
        <template slot-scope="scope"><a v-if="scope.row.links"  :href="scope.row.links" target="_blank">地址</a>
        <a v-else href="#">暂无设置</a></template>
      </el-table-column>
      <el-table-column prop="transit_links" label="中转链接" width="200"></el-table-column>
      <el-table-column prop="operator_id" label="操作员ID" width="100"></el-table-column>
      <el-table-column prop="operator_name" label="操作员姓名" width="130"></el-table-column>

       <el-table-column prop="created_at" label="数据生成时间" width="200">
          <template slot-scope="scope">{{scope.row.created_at|datetime('yyyy-MM-dd hh:mm:ss')}}</template>
      </el-table-column>
      <el-table-column prop="updated_at" label="数据更新时间" width="200">
          <template slot-scope="scope">{{scope.row.updated_at|datetime('yyyy-MM-dd hh:mm:ss')}}</template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <div class="operating-icons">
            <i class="iconfont icon-edit1" @click="editAction(scope.$index, scope.row)"></i>
            <i class="mark iconfont icon-trash-alt1" @click="deleteAction(scope.$index, scope.row)"></i>
          </div>
        </template>
      </el-table-column>
    </el-table>

   <div v-if="total_count > params.pageSize" class="content-padded content-center">
       <el-pagination
               background
               layout="prev, pager, next"
               @current-change="handleCurrentChange"
               :current-page.sync="params.page"
               :total="total_count" :page-size="params.pageSize">
       </el-pagination>
   </div>
    <el-dialog title="添加、编辑宣传链接" width="40%" :visible.sync="memberTagDialog" :before-close="handleCancelLabelsDialog">
      <template>
        <el-form ref="form" :model="form" class="demo-ruleForm" label-width="100px">
          <el-form-item class="content-left" label="所属类型">
            <el-radio-group v-model="form.content_type" size="small">
              <el-radio label="商品" border>商品</el-radio>
              <el-radio label="专题" border>专题</el-radio>
              <el-radio label="品牌" border>品牌</el-radio>
              <el-radio label="充余额" border>充余额</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="form.content_type=='商品'" class="content-left" label="选择商品">
               <el-select v-model="relItemsShops" filterable placeholder="请输入商品货号" remote :remote-method="getItemShopsList" @change="handleItemShopsChange"  style="width: 55%;">
                   <el-option
                           v-for="item in relItemsShopsList"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id"
                   >
                   </el-option>
               </el-select>
               <div v-show="false">
                   <el-col>
                       <el-input v-model="relItemsShopsVal"></el-input>
                   </el-col>
               </div>
          </el-form-item>

          <el-form-item class="content-left" v-else label="链接内容" prop="content">
            <el-input placeholder="链接内容" v-model="form.content"></el-input>
          </el-form-item>
          <el-form-item class="content-left" label="链接类型">
            <el-radio-group v-model="form.links_type" size="small">
              <el-radio label="h5" border>h5</el-radio>
              <el-radio label="custom" border>custom</el-radio>
              <el-radio label="wxapp" border>wxapp</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item class="content-left" label="随机码">
              <el-radio-group v-model="form.rand_flg" size="small">
                  <el-radio label="0" border>非随机</el-radio>
                  <el-radio label="1" border>随机</el-radio>
              </el-radio-group>
          </el-form-item>
          <el-form-item  class="content-left" label="连接地址" prop="cate_name">
            <el-input placeholder="连接地址" v-model="form.links"></el-input>
          </el-form-item>
          <el-form-item v-if="form.links_type=='wxapp'" class="content-left" label="小程序中转" prop="cate_name">
            <el-input placeholder="小程序中转" v-model="form.transit_links"></el-input>
          </el-form-item>

          <el-form-item class="content-center">
            <el-button type="primary" @click="saveData">确定保存</el-button>
          </el-form-item>
        </el-form>
      </template>
    </el-dialog>
  </div>

</template>
<script>
  import { mapGetters } from 'vuex'
  import { getPublicity,addPublicity,updatePublicity,deletePublicity} from '@/api/publicity'
  import {getItemsDetail} from '@/api/goods'
  import {getShopItemsDetailAll} from '@/api/live'

  import SkuSelector from '@/components/function/skuSelector'
  export default {
    data () {
      return {
        data: [],
        upload_at:'',
        loading: false,
        content_types:[
              { value: '商品', name: "商品" },
              { value: '专题', name: '专题' },
              { value: '品牌', name: '品牌' },
              { value: '充余额', name: '充余额' },
          ],
        links_types:[
              { name: 'h5', value: 'h5' },
              { name: 'custom', value: 'custom' },
              { name: 'wxapp', value: 'wxapp' },
          ],
        memberTagDialog: false,
        total_count: 0,
        relItemsShopsVal:"",
        relItemsShopsList:[],
        relItemsShops:"",
        relItems: [],
        item_bn:"",
        params: {
          page: 1,
          pageSize: 20,
        },
        form: {
          id: '',
          content: '',
          content_type: '',
          links_type: '',
          rand_flg:'',
          transit_links:'',
        }
      }
    },
    computed: {
      ...mapGetters([
        'wheight'
      ])
    },
    components: {
        SkuSelector,
    },
    methods: {
      handleCurrentChange () {
        this.getDataList()
      },
      addTemplate () { // 添加商品
        this.memberTagDialog = true
      },
      editAction (index, row) { // 编辑商品弹框
        this.form = row
        this.memberTagDialog = true
      },
      //   选择商品
      getItemShopsList(val){
          getShopItemsDetailAll({page: 1, pageSize: 50,id:val}).then(res => {
              this.relItemsShopsList = [];
              for (let item of res.data.data.list) {
                  console.log(item)
                  this.relItemsShopsList.push({name: item.item_name, id: item.item_id, item_bn:item.item_bn})
              }
              // this.relItemsShopsList = openitems.slice(0,1)
              this.form.links = "https://h5.yaoking.cn/pages/search/ybindex-search-result?bn="+this.relItemsShopsList[0].item_bn
              this.form.content = this.relItemsShopsList[0].name
              this.form.transit_links = "pages/home/searchRes/goods?search_type=goods"
          })
      },
      handleItemShopsChange:function (val){
            this.form.shopsItem = val
      },
      deleteAction (index, row) {

        this.$confirm('此操作将删除数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          deletePublicity(row.id).then(response => {
            this.$message({
              message: '删除成功',
              type: 'success',
              duration: 5 * 1000
            })
            this.getDataList()
          }).catch(() => {
            this.$message({
              type: 'error',
              message: '删除失败'
            })
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
      },
      handleCancelLabelsDialog () {
        this.memberTagDialog = false
      },
      getDataList () {
        this.loading = true
        getPublicity(this.params).then(response => {
          this.data = response.data.data.list
          this.total_count = response.data.data.total_count
          this.loading = false
        })
      },
      searchData () {
        this.getDataList()
      },
      typesearch (){
          this.getDataList()
      },
      saveData () {
        this.memberTagDialog = false
        console.log(this.from)
        if (this.form.id) {
          updatePublicity(this.form.id, this.form).then(res => {
            if (res.data.data) {
              this.$message({
                type: 'success',
                message: '保存成功'
              })
              this.getDataList()
            }
          })
        } else {
          addPublicity(this.form).then(res => {
            if (res.data.data) {
              this.$message({
                type: 'success',
                message: '保存成功'
              })
              this.getDataList()
            }
          })
        }
      },
      updateDateChange (val) {
          if (val && val.length > 0) {
              this.params.start_upload_at = this.dateStrToTimeStamp(val[0] + ' 00:00:00')
              this.params.end_upload_at = this.dateStrToTimeStamp(val[1] + ' 23:59:59')
          } else {
              this.params.start_upload_at = ''
              this.params.end_upload_at = ''
          }
          this.getDataList();
      },
      dateStrToTimeStamp (str) {
          return Date.parse(new Date(str))/1000
      }
    },
    mounted () {
      this.getDataList()
    }
  }
</script>
<style scoped lang="scss">
  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
    img {
      width: 90%;
    }
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 10px;
    img {
      width: 90%;
    }
  }
  .row-bg {
    padding: 10px 20px;
    background-color: #f9fafc;
  }
  .service-label .el-checkbox:first-child{
    margin-left: 15px;
  }
  .service-label .el-input:first-child{
    margin-left: 15px;
  }
  .grid-detail {
    max-height: 300px;
    overflow-y: scroll;
    margin-bottom: 20px;
  }
  .el-carousel {
    width: 375px;
  }
</style>
<style lang="scss">
  .grid-detail {
    table, .detail-content-wrap, .detail-content-item {
      width: 100%!important;
    }
    img {
      width: 100%;
    }
  }
  .grid-attribute {
    table {
      width: 100%!important;
    }
  }
</style>



// WEBPACK FOOTER //
// publicity_links.vue?a2648638